import apiService from './api';

const consultationExamOrderService = {
  list(consultationId) {
    return apiService.get(`/consultations/${consultationId}/exam-orders`);
  },

  sync(consultationId, orders, clinicalAnalysis, clinicalRadiography, clinicalUltrasound) {
    return apiService.put(`/consultations/${consultationId}/exam-orders`, {
      orders,
      clinical_information_analysis: clinicalAnalysis ?? null,
      clinical_information_radiography: clinicalRadiography ?? null,
      clinical_information_ultrasound: clinicalUltrasound ?? null
    });
  },

  add(consultationId, payload) {
    return apiService.post(`/consultations/${consultationId}/exam-orders`, payload);
  },

  remove(consultationId, orderId) {
    return apiService.delete(`/consultations/${consultationId}/exam-orders/${orderId}`);
  }
};

export default consultationExamOrderService;
